import http from "../../services/http";

const getAllAlternativesApi = async (form_id) => {
  return await http("get", `v1/formularios_colaboradores/alternativas/getAll/${form_id}`);
};

const getAlternativesByIdApi = async (id) => {
  return await http("get", `v1/formularios_colaboradores/alternativas/get/${id}`);
};

const createAlternativesApi = async (data) => {
  return await http("post", "v1/formularios_colaboradores/alternativas/create", data);
};

const updateAlternativesApi = async (data) => {
  return await http("post", "v1/formularios_colaboradores/alternativas/update", data);
};

const deleteAlternativesApi = async (id) => {
  return await http("post", "v1/formularios_colaboradores/alternativas/delete", { id: id });
};

export {
  deleteAlternativesApi,
  updateAlternativesApi,
  createAlternativesApi,
  getAlternativesByIdApi,
  getAllAlternativesApi,
};
